/** Female Malayalam speaker for server-side Indic Parler-TTS. */
export const MALAYALAM_TTS_FEMALE_SPEAKER = 'Anjali' as const;

export type MalayalamTtsSpeaker = typeof MALAYALAM_TTS_FEMALE_SPEAKER;

export interface MalayalamTtsSynthesizeRequest {
  text: string;
  speaker: MalayalamTtsSpeaker;
  /** When true, server may cache audio without returning a large body (optional server feature). */
  prefetch?: boolean;
}

export interface MalayalamTtsSpeakOptions {
  muted?: boolean;
  /** Fired before synthesis network request (show loader). */
  onPreparing?: () => void;
  onStart?: () => void;
  onProgress?: (ratio: number) => void;
}
